import React, { Component } from 'react';
import { Glyphicon, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import '../../content/css/DashboardNavbar.css';

export default Object.assign(props => (
    <div className="dashboard-navbar">
        <LinkContainer to={'/dashboard/themes'}>
            <NavItem>
                <Glyphicon glyph='tags' /> Themes
                    </NavItem>
        </LinkContainer>
    </div>),
    { displayName: 'Nav' }
);


// WEBPACK FOOTER //
// ./src/components/Dashboard/NavMenu.js